module.exports = __webpack_public_path__ + "static/media/Desarrollamos@2x.1c88a517.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Desarrollamos@2x.png
// module id = 65
// module chunks = 0